import { render, staticRenderFns } from "./entityObjectAcquisition.vue?vue&type=template&id=6e8469df&scoped=true"
import script from "./entityObjectAcquisition.vue?vue&type=script&lang=js"
export * from "./entityObjectAcquisition.vue?vue&type=script&lang=js"
import style0 from "./entityObjectAcquisition.vue?vue&type=style&index=0&id=6e8469df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8469df",
  null
  
)

export default component.exports